const READY_CHANGE_REPORT = 'READY_CHANGE_REPORT'
const CLEAR_REPORT = 'CLEAR_REPORT'

const responseChangeReport = (title, id, type) => {
  return {
    type: READY_CHANGE_REPORT,
    payload: { title, id, type }
  }
}

const changeReport = (title, id, type) => {
  return (dispatch) => {
    dispatch(responseChangeReport(title, id, type))
  }
}

const clearReportAction = () => {
  return {
    type: CLEAR_REPORT
  }
}

const clearReport = () => {
  return (dispatch) => {
    dispatch(clearReportAction())
  }
}

export {
  changeReport,
  responseChangeReport,
  READY_CHANGE_REPORT,

  clearReport,
  clearReportAction,
  CLEAR_REPORT
}
